import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import * as lodash from 'lodash';
import { Observable, of } from 'rxjs';
import { debounceTime, map, mergeMap } from 'rxjs/operators';

import { LoginService, AccountService } from 'app/shared';



@Injectable({
  providedIn: 'root'
})
export class UnauthGuard implements CanLoad, CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private loginService: LoginService
  ) { }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    if (segments && lodash.toLower(segments[segments.length - 1].path) !== 'sign-in') {
      return of(true);
    }
    return this.allow();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.allow(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.allow(state);
  }

  private allow(state?: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (state && !state.url.includes('/auth/sign-in')) {
      return this.accountService.identity()
        .pipe(
          mergeMap((account) => {
            if (account) {
              return this.loginService.logout();
            }
            return of(null);
          }),
          map(() => {
            return true;
          })
        );
    }
    return this.accountService.identity().pipe(
      debounceTime(1000),
      map((account) => {
        if (!account) {
          return true;
        }
        return this.router.createUrlTree(['/']);
      })
    )
  }
}
